import React, { ReactChild, useState, useEffect } from 'react';
import styles from './Collapsible.module.scss';
import { ReactComponent as Arrow } from './angle-down.svg';
import classNames from 'classnames';

interface CollapsibleProps {
  title?: string;
  isOpen?: boolean;
  children: ReactChild | ReactChild[];
}

const Collapsible = ({ title, children, isOpen }: CollapsibleProps) => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (isOpen) setShowContent(!showContent);
  }, [isOpen]);

  const contentClasses = classNames(styles.content, {
    [styles.contentOpen]: showContent,
  });

  const toggleCollapse = () => {
    setShowContent(!showContent);
  };

  return (
    <div className={styles.collapsible}>
      <button type="button" className={styles.title} onClick={toggleCollapse}>
        {title && <p>{title}</p>}
        <span className={showContent ? styles.iconOpen : styles.iconClosed}>
          <Arrow />
        </span>
      </button>
      {showContent && <div className={contentClasses}>{children}</div>}
    </div>
  );
};

export { Collapsible };
